import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="min-h-screen bg-brand-ceruleanDark flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><Link to="/"><Logo light className="justify-center" /></Link></div>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {sent ? (
            <div className="text-center">
              <h1 className="font-serif text-2xl text-brand-navy">Check your email</h1>
              <p className="text-sm text-brand-slate mt-2">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
              <Link to="/login" className="inline-block mt-6 text-sm text-brand-cerulean hover:underline">← Back to sign in</Link>
            </div>
          ) : (
            <>
              <h1 className="font-serif text-2xl text-brand-navy">Reset password</h1>
              <p className="text-sm text-brand-slate mt-1 mb-6">Enter your account email and we'll send a reset link.</p>
              <form onSubmit={submit} className="space-y-4">
                <div><Label>Email</Label><Input data-testid="forgot-email-input" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-1" required /></div>
                {error && <p className="text-sm text-brand-coral">{error}</p>}
                <Button data-testid="forgot-submit-btn" type="submit" className="w-full bg-brand-cerulean text-white rounded-full">Send Reset Link</Button>
              </form>
              <div className="mt-4 text-center"><Link to="/login" className="text-sm text-brand-cerulean hover:underline">← Back to sign in</Link></div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
